import { User } from './authz/index.js'
import RouteUtils from './RouteUtils.js'

export default class ResourceEnum {
  
  constructor( api, type, isResourceLevel, hasUsers ) {
    this.api = api
    this.type = type
    this.connect = api.child( 'resourceEnum' ).child( type )
    if ( isResourceLevel ) {
      this.resetValues = ( ) => { return this.connect.child( 'resetValues' ).post() }
    }
    if ( hasUsers ) {
      this.user = ( id ) => { return new User( this.connect, id ) },
      this.users = () => { return RouteUtils.authzUsers( this.connect, 'user' ) }
    }
  }

  /**
   * Gets the ResourceEnum
   **/
  get( data ) {
    return this.connect.get( data )
  }

  /**
   * Updates the ResourceEnum header
   */
  update( data ) {
    return this.connect.patchRaw( data )
  }

  /**
   * Removes the ResourceEnum
   */
  remove( ) {
    return this.connect.delete( )
  }

  /**
   * List all enum values
   **/ 
  values( opts ) {
    return this.connect.child( 'value' ).get( opts )
  }

  /**
   * add enum value
   **/ 
  addValue( value, data ) {
    return this.connect.child( 'value' ).child( value ).post( data )
  }

  /**
   * update enum value
   **/ 
  updateValue( value, data ) {
    return this.connect.child( 'value' ).child( value ).patchRaw( data )
  }

  /**
   * remove enum value
   **/ 
  removeValue( value ) {
    return this.connect.child( 'value' ).child( value ).delete( )
  }

  /**
   * returns one enum value
   **/ 
  getValue( value, opts ) {
    return this.connect.child( 'value' ).child( value ).get( opts )
  }
}
